import { ProgramFeatures } from '@citruscamps/citrus-client'
import { faMegaphone } from '@fortawesome/pro-duotone-svg-icons'
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { NavLink } from 'react-router-dom'

export const hasItemRequirements = ({
  flags,
  item,
}: {
  flags?: ProgramFeatures
  item: MenuItemProps
}): boolean =>
  !item.requires ||
  item.requires.length === 0 ||
  item.requires?.every((requirement) => {
    return flags?.[requirement]
  })

type FontAwesomeAnimationProperties =
  | '--fa-beat-scale'
  | '--fa-fade-opacity'
  | '--fa-beat-fade-opacity'
  | '--fa-beat-fade-scale'
  | '--fa-bounce-rebound'
  | '--fa-bounce-height'
  | '--fa-bounce-start-scale-x'
  | '--fa-bounce-start-scale-y'
  | '--fa-bounce-jump-scale-x'
  | '--fa-bounce-jump-scale-y'
  | '--fa-bounce-land-scale-x'
  | '--fa-bounce-land-scale-y'
  | '--fa-flip-x'
  | '--fa-flip-y'
  | '--fa-flip-z'
  | '--fa-flip-angle'
  | '--fa-animation-delay'
  | '--fa-animation-direction'
  | '--fa-animation-duration'
  | '--fa-animation-iteration-count'
  | '--fa-animation-timing'
declare module 'react' {
  interface CSSProperties {
    [key: `--${string}` | FontAwesomeAnimationProperties]: string | number
  }
}

export interface MenuItemProps {
  text: string | React.ReactElement
  icon: IconDefinition
  route: string
  disabled?: boolean
  isUpgrade?: boolean
  requires?: Array<keyof Omit<ProgramFeatures, 'object' | 'program_id'>>
  isBeta?: boolean
  isNew?: boolean
}

interface IProps extends MenuItemProps, React.HTMLAttributes<HTMLLIElement> {}

export const MenuItem = ({
  text,
  icon,
  disabled,
  isUpgrade,
  route,
  isBeta,
  isNew,
  ...props
}: IProps): React.ReactElement => {
  return (
    <li className="nav-item" {...props}>
      <NavLink className={`nav-link ${disabled ? 'disabled' : ''}`.trim()} to={route}>
        <FontAwesomeIcon className="me-3" fixedWidth={true} icon={icon} /> {text}
        {!!isUpgrade && (
          <span className="badge rounded-pill text-bg-light text-capitalize ms-2">Upgrade</span>
        )}
        {!!isBeta && <span className="badge rounded-pill text-bg-light ms-2">Beta</span>}
        {!!isNew && (
          <span className="badge rounded-pill text-bg-info ms-2">
            <FontAwesomeIcon
              icon={faMegaphone}
              className="me-1"
              transform={{ flipX: true }}
              shake
              style={{
                '--fa-animation-iteration-count': 3,
              }}
            />
            New
          </span>
        )}
      </NavLink>
    </li>
  )
}
